<template>
  <div class="app-content content devcontent">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
        <div class="container-fluid">
          <div class="row breadcrumbs-top">
            <div class="col-md-12 content-header-left px-0">
              <h3 class="content-header-title float-left mb-0">
                Escalation Call Log Details
              </h3>

              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div
          class="modal fade"
          id="imagemodal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body p-0">
                <div class="view_photo_transaction">
                  <button
                    type="button"
                    class="close imageModalClose"
                    data-dismiss="modal"
                  >
                    <x-icon
                      size="1.5x"
                      class="custom-class avatar-icon font-medium-3"
                    ></x-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <vue-element-loading :is-full-screen="true" />

        <section id="dashboard-ecommerce" class=" ">
          <div class="card text-center mb-1 p-1 p-md-2">
            <div class="row match-height gateperformanceiconTrakingdb">
                <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5  ">
                    <div class="card text-center my_projects-bgs_co performance_projects-bgs-16 mb-1 cards boxes" id="box1" @click="handleClicked('box1')">
                        <div class="gateperformanceicon">
                            <div class="avatar bg-light-warning p-50 mb-1">
                                <div class="avatar-content avatar_iconsview">
                                    <em class="las la-phone custom-class font-medium-10"></em>
                                </div>
                            </div>
                        </div>
                        <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                           <div class="timeGatetimeview">
                            <span class="avgGatetimeview">{{dataPoints.enroute_stoppage}}</span>
                            </div>
                            <h2 class="font-weight-bolder">Enroute Stoppage </h2>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5 ">
                    <div class="card text-center my_projects-bgs_co performance_projects-bgs-17 mb-1 cards boxes" id="box2" @click="handleClicked('box2')">
                        <div class="gateperformanceicon">
                            <div class="avatar bg-light-warning p-50 mb-1">
                                <div class="avatar-content avatar_iconsview">
                                    <em class="las la-phone custom-class font-medium-10"></em>
                                </div>
                            </div>
                        </div>
                        <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                           <div class="timeGatetimeview">
                            <span class="avgGatetimeview"> {{dataPoints.enroute_stoppage_red_zone}}</span>
                            </div>
                            <h2 class="font-weight-bolder">Enroute Stoppage (Red Zone)  </h2>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5">
                    <div class="card text-center my_projects-bgs_co performance_projects-bgs-19 mb-1 cards boxes" id="box3"  @click="handleClicked('box3')">
                        <div class="gateperformanceicon">
                            <div class="avatar bg-light-warning p-50 mb-1">
                                <div class="avatar-content avatar_iconsview">
                                    <em class="las la-phone custom-class font-medium-10"></em>
                                </div>
                            </div>
                        </div>
                        <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                           <div class="timeGatetimeview">
                            <span class="avgGatetimeview">{{dataPoints.accident}}</span>
                            </div>
                            <h2 class="font-weight-bolder">Accident Calls  </h2>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5 ">
                    <div class="card text-center my_projects-bgs_co performance_projects-bgs-20 mb-1 cards boxes" id="box4"  @click="handleClicked('box4')">
                        <div class="gateperformanceicon">
                            <div class="avatar bg-light-warning p-50 mb-1">
                                <div class="avatar-content avatar_iconsview">
                                    <em class="las la-phone custom-class font-medium-10"></em>
                                </div>
                            </div>
                        </div>
                        <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                           <div class="timeGatetimeview">
                            <span class="avgGatetimeview"> {{dataPoints.breakdown }}</span>
                            </div>
                            <h2 class="font-weight-bolder">Breakdown Calls </h2>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5 "   >
                    <div class="card text-center my_projects-bgs_co performance_projects-bgs-18 mb-1 cards boxes" id="box5" @click="handleClicked('box5')">
                        <div class="gateperformanceicon">
                            <div class="avatar bg-light-warning p-50 mb-1">
                                <div class="avatar-content avatar_iconsview">
                                    <em class="las la-phone custom-class font-medium-10"></em>
                                </div>
                            </div>
                        </div>
                        <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                           <div class="timeGatetimeview">
                            <span class="avgGatetimeview"> {{dataPoints.low_avg_speed}}</span>
                            </div>
                            <h2 class="font-weight-bolder">Low Avg. Speed Maintained </h2>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-sm-6  col-md-3 col-xl-2 gateperformanceicon_col_px5 "  >
                    <div class="card text-center my_projects-bgs_co performance_projects-bgs-15 mb-1 cards boxes" id="box6" @click="handleClicked('box6')">
                        <div class="gateperformanceicon">
                            <div class="avatar bg-light-warning p-50 mb-1">
                                <div class="avatar-content avatar_iconsview">
                                    <em class="las la-phone custom-class font-medium-10"></em>
                                </div>
                            </div>
                        </div>
                        <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                           <div class="timeGatetimeview">
                            <span class="avgGatetimeview"> {{dataPoints.loading_unloading_delay}}</span>
                            </div>
                            <h2 class="font-weight-bolder">Loading/Unloading Delay Calls </h2>
                        </div>
                    </div>
                </div>
                
            </div>
          </div>
          <div class="card">
            <div class="card-body pt-1">
              <div class="row">
                
                <template >
                  <div
                    class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8"
                  >
                    <label class="form-label text-left w-100">Scenario</label>
                    <treeselect
                      placeholder="Select Senario"
                      :options="scenarioList"
                      v-model="search.scenario_master.scenario_id"
                    />
                  </div>
                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8 ">
                    <label class="form-label text-left w-100">Trip Id</label>
                    <input 
                      type="text"
                      class="form-control"
                      placeholder="Enter Trip ID"
                     v-model="search.trip_master.trip_id"
                      />
                </div>
                </template>
                <div
                  class="col-12 col-sm-6 col-md-4 col-lg-4 text-left mb-1 home_das_all_buttons_style mobileview_b_8"
                >
                  <label class="w-100 d-block">&nbsp; </label>
                  <button
                    type="submit"
                    class="btn btn-outline-primary mr-1 waves-effect mr-1"
                    @click="searchFilteredData(search.scenario_master.scenario_id,search.trip_master.trip_id)"
                    
                  >
                    Search
                  </button>
                  <button
                    type="submit"
                    class="btn btn-outline-primary waves-effect mr-1"
                  @click="searchReset()"
                  >
                    clear
                  </button>
                </div>
              </div>
            </div>

            <div class="tab-content">
              <div
                role="tabpanel"
                class="tab-pane active"
                id="report"
                aria-labelledby="gate_tab"
                aria-expanded="true"
              >
                <div
                  class="collapse-margin collapse-icon mt-0"
                  id="faq-cancellation-qna"
                >
                  <div class="card border rounded mb-1 mt-0">
                    <div
                      id="faq-cancellation-one"
                      class=""
                      aria-labelledby="cancellationOne"
                      data-parent="#faq-cancellation-qna"
                    >
                      <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Sr. No</th>
                                    <th>Vehicle Details</th>
                                    <th>Driver Details</th>
                                    <th>Trip ID</th>
                                    <th>Call Details</th>
                                    <th>Call Timing Details</th>
                                    <th>Call Recording</th>
                                </tr>
                            </thead>
                            <tbody>
                                <vue-element-loading
                                  spinner="bar-fade-scale"
                                  :active="isMasterListLoading"
                                />
                                <template v-for="(data, index) in escalation_call_Details.list">
                                    <tr>
                                    <td data-column="Subject" style="text-align: left" > {{index +
                                        1 +
                                        escalation_call_Details.currPageNum *
                                        escalation_call_Details.pagelimit}}
                                    </td>
                                    <td data-column="Vehicle Details" style="text-align: left;">
                                        <span style="font-weight: bold; font-size: smaller;">Vehicle No:</span> <br>
                                        <span style="font-size: smaller;">{{ data.vehicle_registration_number }}</span> <br>
                                        <span style="font-weight: bold; font-size: smaller;">Vehicle Info:</span> <br>
                                        <span style="font-size: smaller;">{{ '-' }}</span>
                                    </td>
                                    <td data-column="Driver Details"  style="text-align: left;">
                                        <span style="font-weight: bold; font-size: smaller;">Name:</span> <br>
                                        <span style="font-size: smaller;">{{ data.call_recipient }}</span> <br>
                                        <span style="font-weight: bold; font-size: smaller;">Mobile No.:</span> <br>
                                        <span style="font-size: smaller;">{{ data.caller_contact ? data.caller_contact : '-' }}</span>
                                    </td>
                                    <td data-column="Priority"  style="text-align: left;"> {{data.trip_id}}</td>
                                    <td data-column="call Details"  style="text-align: left; ">
                                        <span style="font-weight: bold; font-size: smaller;">Call Reason:</span> <br>
                                        <span style="font-size: smaller;">{{ data.call_reason }}</span> <br>
                                        <span style="font-weight: bold; font-size: smaller;">Calling Time:</span> <br>
                                        <span style="font-size: smaller;">{{ formatTimeStampToMonth(data.call_initiation_time) }}</span><br>
                                        <span style="font-weight: bold; font-size: smaller;">Calling To:</span> <br>
                                        <span style="font-size: smaller;">{{ data.call_recipient_rank }}</span><br>
                                        <span style="font-weight: bold; font-size: smaller;">Escalation Level:</span> <br>
                                        <span style="font-size: smaller;">{{ data.escalation_level }}</span> 
                                    </td>
                                    <td data-column="call timing Details text-nowrap"  style="text-align: left; ">
                                        <span style="font-weight: bold; font-size: smaller;">Call Start Time:</span>
                                        <span style="font-size: smaller; display: inline-block;">{{ formatTimeStampToMonth(data.call_start_time) }}</span>
                                        <br>
                                        <span style="font-weight: bold; font-size: smaller;">Call End Time:</span>
                                        <span style="font-size: smaller; display: inline-block;">{{ formatTimeStampToMonth(data.call_end_time) }}</span>
                                        <br>
                                        <span style="font-weight: bold; font-size: smaller;">Duration: </span>
                                        <span style="font-size: smaller; display: inline-block;">{{ data.call_duration ? `${data.call_duration} hrs` : '-' }} </span>
                                    </td>

                                    <td data-column="Priority"  style="text-align: left; ">
                                        <div style="display: flex; align-items: center;">
                                            <!-- <a >{{ data.url }}</a> -->
                                            <a href="../../../public/recordings/call_record_2412124.mp3" download target="_blank" style="margin-left: 20px;">
                                                <i class="las la-download custom-class" style="font-weight: bold; font-size: 20px;"></i>
                                            </a>
                                        </div>
                                    </td>
                                    </tr>
                                </template>
                                <template
                                  v-if="!escalation_call_Details.list.length"
                                >
                                  <tr>
                                    <td colspan="14" style="text-align: center">
                                      No records found
                                    </td>
                                  </tr>
                                </template>
                            </tbody>
                        </table>
                      </div>
                      <div
                        class="pageCenter text-center mt-4 pagination_viewallpages"
                      >
                        <pagination
                          v-model="escalation_call_Details.page"
                          :records="escalation_call_Details.totalcount"
                          :per-page="escalation_call_Details.pagelimit"
                          @paginate="
                            (e) =>
                              handlePageChange(e, 'escalation_call_Details')
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Treeselect from "@riophae/vue-treeselect";
import VueElementLoading from "vue-element-loading";
import {
  XCircleIcon,
  FileIcon,
  UploadIcon,
  DownloadIcon,
  EditIcon,
  XIcon,
} from "vue-feather-icons";
import CONSTANT from "../../constants.js";
import { read, utils } from "xlsx";
// import schema from "../../utils/schema";
import common_methods from "../../utils/common_methods.js";
import searchMasterNameList from "../../utils/searchMasterNameList";

export default {
  name: "escalationcalldetails",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    DatePicker,
    VueElementLoading,
    Pagination,
    UploadIcon,
    FileIcon,
    XCircleIcon,
    DownloadIcon,
    EditIcon,
    XIcon,
  },
  data() {
    return {
      isLoading: false,
      isMasterListLoading: false,
      escalation_call_Details: {
        url: "/escalation/call-logs",
        list: [],
        totalcount: 0,
        pageCount: 0,
        page: 1,
        pagelimit: CONSTANT.LIMIT,
        currPageNum: 0,
        pageoffset: 1,
      },
      defaultSearchTab:null,
      searchFilters:[
        {id:'scenario',label:'Scenario'},
        {id:'trip',label:'Trip'}
      ],
      searchKey:'scenario',
      scenarioList:[],
      search:{
        scenario_master:{
            scenario_id:null
        },
        trip_master:{
          trip_id:''
        }
      },
      dataPoints: {
            "enroute_stoppage": 0,
            "enroute_stoppage_red_zone": 0,
            "accident": 0,
            "breakdown": 0,
            "low_avg_speed": 0,
            "loading_unloading_delay": 0
        }
    };
  },
  created() {
   this.getMasterList();
   this.getscenarioList();
   this.getDataPoints();
  },
  mounted() {},
  methods: {
    getDataPoints() {
      axios({
        method: "POST",
        url: "/stats/escalation-stats",
      })
        .then((result) => {
          if (result.data.status) {
            this.dataPoints = result.data.data
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getMasterList(currTab = "escalation_call_Details") {
      this.isMasterListLoading = true;
      let tab = this[currTab];
      let url = tab.url;
        let scenario_id=this.search.scenario_master.scenario_id;
        let trip_id = this.getTrimmedString(this.search.trip_master.trip_id);
      let payload = {
        scenario_id :scenario_id,
        trip_id:trip_id,
        rows: CONSTANT.LIMIT,
        page: tab.pageoffset,
      };
      axios({
        method: "POST",
        url,
        data: payload,
      })
        .then((result) => {
          this.isMasterListLoading = false;
          if (result.data.status) {
            tab.list = result.data.data.rows;
            // console.log(tab.list)
            tab.totalcount = result.data.data.count;
            tab.pageCount = Math.ceil(tab.totalcount / tab.pagelimit);
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
            tab.totalcount = 0;
            tab.pageCount = 0;
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    handlePageChange(pageNum, tab = "escalation_call_Details") {
      this[tab].pageoffset = pageNum;
      this[tab].currPageNum = pageNum - 1;
      this.getMasterList(tab);
      setTimeout(() => {
        $("html, body").animate({
          scrollTop: $(`#${tab}`).offset().top - 70,
        });
      }, 500);
    },
    getscenarioList() {
      this.isLoading = true;
      this.searchNameMasterList("ct_scenarios", "scenario", null, "scenario_id")
        .then((result) => {
          this.isLoading = false;
          this.scenarioList = result.data;
         // console.log(this.scenarioList)
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    searchFilteredData(id,trip_id){
        if(id)
        {
            this.getMasterList();
        }else if(trip_id)
        {
          this.getMasterList();
        }
        else{
          this.sweetAlertSnackbar("Select Scenario")
        }

    },
    searchReset(){
        this.search ={
            scenario_master:{
                scenario_id:null
            },
            trip_master:{
              trip_id:null
            }
        }
        
        this.getMasterList()
    },
    toggleCurrentBox(){
      let allBoxes = document.querySelectorAll('.boxes');
      for(let box of allBoxes){
        box.classList.remove("currentBox")
      }
    },
    handleClicked(id){
     this.toggleCurrentBox()
     let currentBox = document.getElementById(id)
     currentBox.classList.add("currentBox")
    },
  }
};
</script>
<style scoped>

.currentBox {
 background-color:black !important;
}

.filters div,
.active{
  background-color:grey;
  padding:5px
}
.cards{
  cursor:pointer
}

.tabs_dockview .active button {
  background: #ff9800;
  color: #fff;
}
.innerphoto_details_doc_04 {
  width: 140px;
  display: flex;
  border-bottom: 1px solid #dbdbdb;
  max-height: 140px;
  min-height: 140px;
  align-items: center;
  margin: 0px auto;
  overflow: hidden;
}
</style>
